var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_23951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12H23V10H13V12H11C9.9 12 9 12.9 9 14V15C9 17.55 10.92 19.63 13.39 19.94C14.02 21.44 15.37 22.57 17 22.9V26H13V28H23V26H19V22.9C20.63 22.57 21.98 21.44 22.61 19.94C25.08 19.63 27 17.55 27 15V14C27 12.9 26.1 12 25 12ZM11 15V14H13V17.82C11.84 17.4 11 16.3 11 15ZM25 15C25 16.3 24.16 17.4 23 17.82V14H25V15Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_23951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDetails);
export default __webpack_public_path__ + "static/media/eventDetails.c4aff3883d893ea26261eebcf0381be9.svg";
export { ForwardRef as ReactComponent };